export default __webpack_public_path__ + "e150852ee1beab8534efad0384b04d72.jpg";